import styled from 'styled-components';

export const StyledDataSectionContainer = styled.section`
  border-radius: 15px;
  border: 1px solid ${(props) => props.theme.accent2};
  background: ${(props) => props.theme.bg3};

  padding: 1rem;
`;
